import './SingleValue.css';
export var container = '_1sfgzlg0-3-12-1';